/**
 * Stable id for @dnd-kit SortableContext items (must line up with `useSortable({ id })`).
 * Mirrors prior React `key` selection: id → key → preview → index fallback.
 */
export function getSortableImageId(item: { id?: number; key?: string; preview?: string }, index: number): string {
  if (item.id != null && item.id !== undefined) return `id:${item.id}`
  if (item.key) return `key:${item.key}`
  if (item.preview) return `preview:${item.preview}`
  return `idx:${index}`
}
